import { Reveal, SectionTag, MaskedLines } from "@/components/Reveal";

const FOCUS_AREAS = [
  {
    num: "01",
    title: "Consumer Services",
    copy: "Building easier ways for customers to discover and access everyday services.",
  },
  {
    num: "02",
    title: "Workforce & Service Networks",
    copy: "Creating structured systems that connect customer demand with service professionals and distributed service networks.",
  },
  {
    num: "03",
    title: "Digital Service Platforms",
    copy: "Using technology to manage discovery, enquiries, matching, transactions, communication and service operations.",
  },
];

export default function Focus() {
  return (
    <section
      id="focus"
      data-testid="focus-section"
      className="scroll-mt-20 border-t border-white/5 bg-[#0E0D09] py-20 sm:py-24"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <SectionTag index="06">Our Focus</SectionTag>
        </Reveal>
        <div className="mt-6 grid gap-10 lg:grid-cols-2">
          <h2
            data-testid="focus-headline"
            className="font-serif text-3xl font-normal leading-[1.12] tracking-tight text-slate-100 sm:text-4xl lg:text-[44px]/[1.14]"
          >
            <MaskedLines delay={0.1}>
              Building technology-enabled
              <br />
              <span className="italic text-transparent bg-gradient-to-r from-[#F0DDA6] via-[#E7CE8B] to-[#C9A227] bg-clip-text">
                service businesses.
              </span>
            </MaskedLines>
          </h2>
          <Reveal delay={0.2}>
            <p className="max-w-xl self-end text-base font-normal leading-relaxed text-slate-300 sm:text-lg lg:ml-auto">
              We focus on service markets where technology and structured
              operations can make discovery, access, fulfilment and customer
              experience more efficient.
            </p>
          </Reveal>
        </div>

        {/* three large editorial columns — where Logibyte builds */}
        <div
          data-testid="focus-areas-grid"
          className="mt-16 grid gap-12 lg:grid-cols-3 lg:gap-0"
        >
          {FOCUS_AREAS.map((f, i) => (
            <Reveal key={f.num} delay={0.1 * i} className="h-full">
              <div
                data-testid={`focus-area-${i + 1}`}
                className={`group relative h-full border-t border-[#D4AF37]/25 pt-8 lg:px-10 lg:py-0 lg:pt-8 ${
                  i > 0 ? "lg:border-l lg:border-white/10" : "lg:pl-0"
                }`}
              >
                <span className="font-serif text-5xl font-normal leading-none tracking-tight text-white/[0.06] transition-colors duration-700 group-hover:text-[#D4AF37]/20" aria-hidden="true">
                  {f.num}
                </span>
                <h3 className="mt-6 font-serif text-xl font-normal uppercase leading-snug tracking-tight text-slate-100 transition-colors duration-500 group-hover:text-[#E7CE8B] sm:text-2xl">
                  {f.title}
                </h3>
                <span className="mt-6 block h-px w-12 bg-gradient-to-r from-[#D4AF37]/60 to-transparent transition-all duration-700 group-hover:w-20 group-hover:from-[#E7CE8B]" aria-hidden="true" />
                <p className="mt-6 max-w-sm text-[15px] font-normal leading-relaxed text-stone-400 transition-colors duration-500 group-hover:text-stone-300 sm:text-base">
                  {f.copy}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
